<template>
  <div class="p-4">
    <div dir="rtl" class="flex gap-4 snap-x py-2 flex-col justify-center">
      <div class="flex gap-x-2">
        <Select2
          id="category"
          class="select-form w-full"
          :options="DropCategory"
          :settings="{ width: '100%' }"
          @select="ChangeDropCategory($event)"
          placeholder="انتخاب دسته بندی"
        />
        <Select2
          id="line"
          class="select-form w-full overflow-x-hidden"
          :options="DropLine"
          :settings="{ width: '100%' }"
          @select="ChangeDropLine($event)"
          :disabled="DropLine.length <= 0"
          placeholder="انتخاب خط"
        />
      </div>
      <Select2
        id="product"
        class="select-form w-full"
        :options="DropProduct"
        :settings="{ width: '100%' }"
        @select="ChangeDropProduct($event)"
        placeholder="انتخاب محصول"
        :disabled="DropProduct.length <= 0"
      />
      <CustomDatePicker class="w-full" v-model="day" :disabled="!isShowDate" />
      <div class="flex gap-x-2 justify-center">
        <input
          type="radio"
          id="month"
          name="radio"
          value="month"
          v-model="ReportType"
          :disabled="day==''"
        />
        <label for="month">گزارش ماهانه</label>
        <input
          type="radio"
          id="day"
          name="radio"
          value="day"
          v-model="ReportType"
          :disabled="day==''"
        />
        <label for="day">گزارش روزانه</label>
      </div>
    </div>
    <ChartViewer
      :Category="slectedCategory"
      :Line="slectedLine"
      :Product="selectedProduct"
      :year="selectedYear"
      :month="selectedMonth"
      :day="selectedDay"
    />
  </div>
</template>
<script>
import { chartReport } from "@/API/API";
import Select2 from "vue3-select2-component";
import ChartViewer from "@/components/ChartViewer.vue";
import jDate from "jalali-date";

export default {
  name: "ReportChart",
  components: { Select2, ChartViewer },
  data() {
    return {
      selectedDay: "",
      selectedMonth: "",
      selectedProduct: "",
      selectedYear: "",
      slectedLine: "",
      slectedCategory: "",
      daysInMonth: "",
      Line: [],
      Category: [],
      DropLine: [],
      DropCategory: [],
      Product: [],
      DropProduct: [],
      day: "",
      isShowDate: false,
      ReportType: "",
    };
  },
  methods: {
    async getCategory() {
      (this.DropCategory = []),
        (this.Category = (await chartReport()).data.result);
      this.Category.forEach((item) => {
        this.DropCategory.push({
          text: item.colKeyValue + " - " + item.colKey,
          id: item.colKeyValue,
        });
      });
    },
    async ChangeDropCategory({ id }) {
      (this.DropLine = []),
        (this.DropProduct = []),
        (this.slectedCategory = id);
      this.Line = (await chartReport(id)).data.result;
      this.Line.forEach((item) => {
        this.DropLine.push({
          text: item.colKeyValue1 + " - " + item.colKey1,
          id: item.colKeyValue1,
        });
      });
    },
    async ChangeDropLine({ id }) {
      (this.DropProduct = []), (this.slectedLine = id);
      this.Product = (await chartReport(this.slectedCategory, id)).data.result;
      this.Product.forEach((item) => {
        this.DropProduct.push({
          text: item.colKeyValue2 + " - " + item.colKey2,
          id: item.colKeyValue2,
        });
      });
    },
    ChangeDropProduct({ id }) {
      this.selectedProduct = id;
      this.isShowDate = true;
    },
    getMonthReport() {
      this.selectedYear = "";
      this.selectedMonth = "";
      this.selectedDay = "";
      const PMjdate = new jDate(new Date(this.day));
      this.selectedYear = PMjdate.getFullYear();
      this.selectedMonth = PMjdate.getMonth();
    },
    getDayReport() {
      this.selectedYear = "";
      this.selectedMonth = "";
      this.selectedDay = "";
      const PDjdate = new jDate(new Date(this.day));
      this.selectedYear = PDjdate.getFullYear();
      this.selectedMonth = PDjdate.getMonth();
      this.selectedDay = PDjdate.getDate();
    },
  },
  created() {
    this.getCategory();
  },
  watch: {
    ReportType() {
      if (this.ReportType == "month") {
        this.getMonthReport();
      } else if (this.ReportType == "day") {
        this.getDayReport();
      }
    },
  },
};
</script>
<style scoped>
.select-form {
  transition: 0.3s;
  color: #111;
  box-shadow: 0 0 10px rgb(0 0 0 / 15%);
  border-radius: 5px;
}
</style>
